<template>
    <div class="store">
        <van-nav-bar title="申请入驻" />
        <div v-if="isstore" class="isStore"></div>
        <div class="noStore">
            <img src="../images/store.jpg" alt="" />
            <!-- <img src="../images/mid.jpg" alt="" @click="goJoin" /> -->
            <img src="../images/mid.gif" alt="" class="gif" @click="goJoin" />
            <!-- <img src="../images/bottom.jpg" alt="" /> -->
            <!-- <van-empty class="custom-image" image="https://www.psciio.com/idcard/aacaca5de5b9490fa7d4ba6642946818.png" />
            <div class="no">你尚未入驻商家机构</div>
            <div class="apply" @click="goJoin">申请入驻</div> -->
        </div>
    </div>
</template>

<script>
import { selectIsStore } from '../api/index';
export default {
    data() {
        return {
            isstore: false,
            phone: ''
        };
    },
    methods: {
        onClickLeft() {},
        goJoin() {
            this.$router.push('/Joininfo');
            // window.open('https://userinner.pzhszgh.cn/#/Joininfo?phone=‘xxx’')
        },
        async isStores() {
            selectIsStore({ phone: this.$globalData.phone1 }).then((res) => {
                console.log(res);
                if (res.message === '当前用户电话没有对应商家' || res.data.mallorg.audit !== 2) {
                    // this.$toast({
                    //     message: '不是商家'+this.$globalData.phone1,
                    //     position: 'center'
                    // });
                } else {
                    // this.$toast({
                    //     message: '手机号'+this.$globalData.phone1,
                    //     position: 'center'
                    // });
                    this.$router.push({ path: '/index', query: { phone: this.$globalData.phone1 } });
                }
            });
        }
    },
    created() {
        this.phone = this.$route.query.phone;
        this.$root.$globalData.phone1 = this.$route.query.phone;

        // this.$root.$globalData.phone1 = 13198566796;
        this.isStores();
    }
};
</script>

<style lang="scss" scoped>
.orange {
    color: #ff6633;
}
.store {
    .noStore {
        img {
            width: 100%;
            display: block;
        }
        .gif{
            position: absolute;
            top: 450px;
            left: 173px;
            width: 160px;
        }
        // position: fixed;
        // top: 25%;
        // left: 50%;
        // transform: translateX(-50%);
        // .no {
        //     text-align: center;
        //     font-size: 20px;
        //     font-weight: 800;
        // }
        // .apply {
        //     display: flex;
        //     align-items: center;
        //     justify-content: center;
        //     margin: 20px auto;
        //     width: 250px;
        //     height: 40px;
        //     background: #ff6633;
        //     font-size: 17px;
        //     border-radius: 6px;
        //     color: #fff;
        // }
    }
}
</style>
